"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixTextCaret = fixTextCaret;
const tex_syntax_1 = require("./tex-syntax");
const textWithBlockArg = new RegExp(`\\\\text(${(0, tex_syntax_1.block)(3)})`, "g");
function fixCaretsInsideInnerBlock(tex) {
    return tex.replace(/(\$[^$]*\$)|(\\\^[a-z])|([\\^])/g, (token) => {
        if (token === "^") {
            return "\\unicode{0x005e}";
        }
        return token;
    });
}
function fixTextCaret(tex) {
    return tex
        .replace("\\dfrac{27}{25} \\text^2", "\\dfrac{27}{25} \\text{^}2")
        .replace("\\text ^+(aq)", "\\text{^}+(aq)")
        .replace(
    // Find all occurrences of \text followed by a block...
    textWithBlockArg, 
    // ...and fix up the contents of the block...
    (_, innerBlock) => {
        return `\\text${fixCaretsInsideInnerBlock(innerBlock)}`;
    });
}
